export default class Storage {
  static get(key) {
    return localStorage.getItem(key);
  }

  static remove(key) {
    localStorage.removeItem(key);
  }

  static set(key, value) {
    localStorage.setItem(key, value);
  }

  /**
    @params String[] keep 
    supply localstorage variable to keep from clearing
   */
  static clear(keep) {
    const values = {};
    keep.forEach(k => values[k] = this.get(k));
    localStorage.clear();
    keep.forEach(k => this.set(k, values[k]));
  }
}